export default function getChannelURL(channelName: string): string {
    switch (window.location.hostname) {
        case "dev.spot-on.media":
            return `https://dev-live.spot-on.media/${channelName}/spoton.m3u8`;
        case "acc.spot-on.media":
            return `https://acc-live.spot-on.media/${channelName}/spoton.m3u8`;
        case "spot-on.media":
            return `https://live.spot-on.media/${channelName}/spoton.m3u8`;
        default:
            return `https://live.spot-on.media/${channelName}/spoton.m3u8`;
    }
}
